
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h38v38H0z"}}),_c('path',{attrs:{"d":"M8.5 12.5h22M8.5 25h22M5 10h3M5 16h3M5 22h3M5 28h3M4.5 8v22M8 8v22M31.5 10h3M31.5 16h3M31.5 22h3M31.5 28h3M31 8v22M34.5 8v22","stroke":"#000","stroke-width":"1.5"}})])
      }
    
      }
    